/* MTD Header — mobile drawer, dropdown behaviour, sticky shadow. */
(function () {
  'use strict';

  function init(header) {
    if (header.dataset.mtdReady === 'true') return;
    header.dataset.mtdReady = 'true';

    var burger = header.querySelector('[data-mtd-burger]');
    var drawer = header.querySelector('[data-mtd-drawer]');
    var panel = header.querySelector('.mtd-header__drawer-panel');

    /* ---------- Mobile drawer ---------- */
    function openDrawer() {
      drawer.hidden = false;
      // Next frame, so the transform transition actually runs.
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Close menu');
      document.body.style.overflow = 'hidden';
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
      document.body.style.overflow = '';
      // Wait for the slide-out before removing it from the tree.
      setTimeout(function () { drawer.hidden = true; }, 250);
      burger.focus();
    }

    if (burger && drawer) {
      burger.addEventListener('click', function () {
        drawer.hidden ? openDrawer() : closeDrawer();
      });
      header.querySelectorAll('[data-mtd-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
      });
    }

    /* ---------- Desktop dropdowns ---------- */
    var dropdowns = header.querySelectorAll('[data-mtd-dropdown]');

    // Only one open at a time.
    dropdowns.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        dropdowns.forEach(function (other) { if (other !== d) other.open = false; });
      });
    });

    // Click outside, or tab away, closes them.
    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('focusin', function (e) {
      dropdowns.forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dropdowns.forEach(function (d) { d.open = false; });
    });

    /* ---------- Sticky shadow ---------- */
    if (header.classList.contains('mtd-header--sticky')) {
      var onScroll = function () {
        header.classList.toggle('is-stuck', window.scrollY > 4);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function boot() { document.querySelectorAll('[data-mtd-header]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-mtd-header]').forEach(init);
  });
})();
